import { Component, Input } from '@angular/core';
import { AppointmentCalendar, CalendarDayFields, AppointmentCalendarData } from './../../models/calendar/calendar.model';
import * as moment from 'moment';

@Component({
  selector: 'swb-appointments-calendar',
  templateUrl: './appointments-calendar.component.html'
})
export class AppointmentsCalendarComponent {

  public day: moment.Moment;

  public calendar: AppointmentCalendar;

  public appointments: Array<any> = [];

  @Input()
  public set data(data: AppointmentCalendarData) {
    this.day = data.day;

    if (data.calendar) {

      this.calendar = data.calendar;

      const fromConfigured = data.calendar[CalendarDayFields.get(data.day.day()) + '_from'];
      const toConfigured = data.calendar[CalendarDayFields.get(data.day.day()) + '_to'];

      if (!fromConfigured || !toConfigured) {
        return;
      }

      const splitFromConfigured = fromConfigured.split(/:/);
      const splitToConfigured = toConfigured.split(/:/);


      const from = moment(this.day).utc().hours(splitFromConfigured[0]).minutes(splitFromConfigured[1]);
      const to = moment(this.day).utc().hours(splitToConfigured[0]).minutes(splitToConfigured[1]);

      this.appointments = [];

      let finished = false;
      const time = from;
      if (time.isValid()) {
        for (let i = 0; !finished; i += data.calendar.minute_interval) {

          if (i > 0) {
            time.add(data.calendar.minute_interval, 'minutes');
          }

          const isBooked = data.calendar.appointment_calendar_bookings.some(b =>
            !b.cancelled &&
            moment.utc(b.datetime_from) < time.clone().utc().add(data.calendar.minute_interval, 'minutes')
            && moment.utc(b.datetime_to) > time);

          const isCancelled = data.calendar.appointment_calendar_bookings.some(b =>
            b.cancelled &&
            moment.utc(b.datetime_from) < time.clone().utc().add(data.calendar.minute_interval, 'minutes')
            && moment.utc(b.datetime_to) > time);


          const isDisabled = data.calendar.appointment_calendar_holidays.some(h =>
            moment.utc(h.datetime_from) < time.clone().utc().add(data.calendar.minute_interval, 'minutes')
            && moment.utc(h.datetime_to) > time);

          const timeObject = {
            value: time.format('HH:mm'),
            isBooked: isBooked,
            isDisabled: isDisabled,
            isCancelled: isCancelled
          };

          this.appointments.push(timeObject);
          if (time >= to.utc().clone().subtract(data.calendar.minute_interval, 'minutes')) {
            finished = true;
          }
        }
      }

    }

  }

}
